export const CPAP_SIDE_EFFECT_OPTIONS = [
  "หน้ากากไม่พอดี/รั่ว",
  "เจ็บบริเวณใบหน้า/ดั้งจมูก",
  "ผิวหนังระคายเคือง/เป็นผื่น",
  "เสียงเครื่อง/หน้ากากดัง",
  "คัดจมูก/น้ำมูกไหล",
  "ปากแห้ง/คอแห้ง",
  "ท้องอืด/แน่นท้อง",
  "นอนไม่หลับ",
];

export const LEGACY_CPAP_SIDE_EFFECT_OPTIONS = [
  "จมูกแห้ง/คอแห้ง",
  "แน่นจมูก/น้ำมูกไหล",
  "ระคายเคืองผิวหนังบริเวณหน้ากาก",
  "ลมรั่วจากหน้ากาก",
  "ท้องอืด/กลืนลม",
  "นอนหลับไม่สบายจากเครื่อง",
  "ไม่มีผลข้างเคียง",
];

export const CPAP_PDF_SIDE_EFFECT_OPTIONS =
  LEGACY_CPAP_SIDE_EFFECT_OPTIONS;

const normalizeSideEffectText = (value = "") => {
  const text = String(value || "")
    .replace(/\u0000/g, "")
    .replace(/\uF70A/g, "\u0E48")
    .replace(/\uF70B/g, "\u0E49")
    .replace(/\uF70E/g, "\u0E4C")
    .toLowerCase();

  return text.replace(/[^a-z0-9\u0E00-\u0E7F]+/gi, "");
};

const buildOptionDefinitions = (options) =>
  options.map((value) => ({
    value,
    aliases: [value],
  }));

const PDF_SIDE_EFFECT_TEMPLATES = [
  {
    id: "current",
    titleAliases: [
      "ปัญหาและข้างเคียงที่พบ",
      "ปัญหาและผลข้างเคียงที่พบ",
      "Problems & Side Effects",
    ],
    options: CPAP_SIDE_EFFECT_OPTIONS,
    optionDefinitions: buildOptionDefinitions(CPAP_SIDE_EFFECT_OPTIONS),
  },
  {
    id: "legacy",
    titleAliases: ["ผลข้างเคียงจากการใช้ CPAP"],
    options: CPAP_PDF_SIDE_EFFECT_OPTIONS,
    optionDefinitions: buildOptionDefinitions(
      CPAP_PDF_SIDE_EFFECT_OPTIONS,
    ),
  },
];

const containsNormalizedText = (text, value) => {
  const normalizedValue = normalizeSideEffectText(value);
  return normalizedValue && text.includes(normalizedValue);
};

export const matchCpapSideEffectPdfTemplate = (text = "") => {
  const normalizedText = normalizeSideEffectText(text);
  const matches = PDF_SIDE_EFFECT_TEMPLATES.map((template) => {
    const titleMatched = template.titleAliases.some((alias) =>
      containsNormalizedText(normalizedText, alias),
    );
    const matchedOptionCount = template.optionDefinitions.filter(
      (definition) =>
        definition.aliases.some((alias) =>
          containsNormalizedText(normalizedText, alias),
        ),
    ).length;

    return {
      ...template,
      titleMatched,
      matchedOptionCount,
      score: (titleMatched ? 100 : 0) + matchedOptionCount,
    };
  }).sort((left, right) => right.score - left.score);

  return matches[0];
};

export const matchesCpapSideEffectOptionText = (text, definition) => {
  const normalizedText = normalizeSideEffectText(text);

  return definition.aliases.some((alias) =>
    containsNormalizedText(normalizedText, alias),
  );
};

export const getCpapSideEffectOptionsForDisplay = () => [
  ...CPAP_PDF_SIDE_EFFECT_OPTIONS,
];

export const getSavedNonPdfCpapSideEffectValues = (selectedValues = []) => {
  if (!Array.isArray(selectedValues)) return [];

  const nonPdfValues = selectedValues
    .map((value) => String(value || "").trim())
    .filter(
      (value) =>
        value && !CPAP_PDF_SIDE_EFFECT_OPTIONS.includes(value),
    );

  return Array.from(new Set(nonPdfValues));
};

export const updateCpapSideEffectSelection = (
  selectedValues,
  option,
  checked,
) => {
  const current = Array.isArray(selectedValues) ? selectedValues : [];

  return checked
    ? Array.from(new Set([...current, option]))
    : current.filter((value) => value !== option);
};
